import React, { useState } from 'react';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  joinChat: { id: 'liveChatJoin', defaultMessage: 'Join the chat' },
  nickname: { id: 'liveChatNickname', defaultMessage: 'Nickname' },
  join: { id: 'liveChatJoinButton', defaultMessage: 'Join' },
});

const ChatNickname = ({ onJoin, suggestedName }) => {
  const intl = useIntl();
  const [name, setName] = useState(suggestedName || '');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name.trim()) {
      onJoin(name.trim());
    }
  };

  return (
    <div className="live-chat-nickname">
      <h3 className="live-chat-nickname-title">
        {intl.formatMessage(messages.joinChat)}
      </h3>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          className="live-chat-nickname-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={intl.formatMessage(messages.nickname)}
          aria-label={intl.formatMessage(messages.nickname)}
          maxLength={30}
        />
        <button
          type="submit"
          className="live-chat-nickname-btn"
          disabled={!name.trim()}
        >
          {intl.formatMessage(messages.join)}
        </button>
      </form>
    </div>
  );
};

export default ChatNickname;
